import { Dialog, DialogContent, IconButton, Slide } from '@mui/material'
import { Close } from '@mui/icons-material'
import { forwardRef, useState } from 'react'
import { Navigation, Pagination, Scrollbar, A11y, EffectCreative, Keyboard, Zoom } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import LoadingLogoDialog from './LoadingLogoDialog'
const Transition = forwardRef(function Transition (props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const ImageAstDialog = ({ open, handleClose, images, setIsEdited, indexSlide }) => {
    console.log(images)

    const [sliderIndex, setSliderIndex] = useState()
    const [openLoadingLogoModal, setOpenLoadinlogoModal] = useState(false)
    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            adaptiveHeight={true}
        >
            <DialogContent className="dialog-content-ast">
                <Swiper
                    grabCursor={true}
                    effect={'creative'}
                    creativeEffect={{
                        prev: {
                            shadow: true,
                            translate: [0, 0, -400]
                        },
                        next: {
                            translate: ['100%', 0, 0]
                        }
                    }}
                    zoom={true}
                    modules={[Zoom, Navigation, Pagination, Scrollbar, A11y, EffectCreative, Keyboard]}
                    spaceBetween={50}
                    slidesPerView={1}
                    navigation
                    keyboard={{
                        enabled: true
                    }}
                    style={{
                        '--swiper-navigation-color': '#be2e26',
                        '--swiper-pagination-color': '#be2e26'
                    }}
                    className="mySwiper"
                    pagination={{ clickable: true }}
                    initialSlide={indexSlide}
                    /* scrollbar={{ draggable: false }} */
                    onSwiper={(swiper) => setSliderIndex(swiper.activeIndex)}
                    onSlideChange={(e) => setSliderIndex(e.activeIndex)}
                >
                    {
                        images && images.length > 0 && images.map((element, index) => {
                            console.log(element)
                            const url = element.includes('http') ? element : element.url ? element.url : element.urlBase64
                            return (
                                <SwiperSlide key={index} style={{ height: '80vh', display: 'block', width: '100%', textAlign: 'center' }}>
                                    <div className="swiper-zoom-container">
                                        <img
                                            key={index}
                                            src={url}
                                            style={{ height: '95vh', textAlign: 'center' }}
                                        />
                                    </div>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
            </DialogContent>
            <IconButton
                style={{ position: 'absolute', zIndex: 2, top: 20, right: 20, backgroundColor: '#fff' }}
                onClick={handleClose}
            >
                <Close />
            </IconButton>
            <LoadingLogoDialog open={openLoadingLogoModal} />
        </Dialog>
    )
}

export default ImageAstDialog
